import { render } from "./DifficultiesComp.vue?vue&type=template&id=1593020c&scoped=true"
import script from "./DifficultiesComp.vue?vue&type=script&lang=js"
export * from "./DifficultiesComp.vue?vue&type=script&lang=js"

import "./DifficultiesComp.vue?vue&type=style&index=0&id=1593020c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1593020c"]])

export default __exports__